import { Link } from 'react-router-dom'
import Seo from '@/components/Seo'

function NotFound() {
  return (
    <>
      <Seo title="Page not found | Dormer Calculator" description="The page you are looking for does not exist." path="/404" noindex />
      <div className="container-page py-24 text-center">
        <p className="eyebrow">Error 404</p>
        <h1 className="mt-2 text-4xl">That page is not on the roof plan</h1>
        <p className="mx-auto mt-3 max-w-md text-lg">The link may be broken or the page may have moved. Try the calculator or browse the blog.</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link to="/calculator" className="btn btn-primary no-underline">Open calculator</Link>
          <Link to="/blog" className="btn btn-outline no-underline">Browse the blog</Link>
        </div>
      </div>
    </>
  )
}

export default NotFound
